import React from 'react';
import { VENTAS_IGV_OPTIONS } from '../../utils/ventasIgvUtils';

const IgvRateSelect = ({
  value,
  onChange,
  disabled = false,
  id = 'igv_rate',
  name = 'igv_rate',
  className = '',
  label = 'Tasa de IGV',
  showLabel = false,
}) => (
  <div>
    {showLabel && (
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2 min-h-[28px]">
        {label}
      </label>
    )}
    <select
      id={id}
      name={name}
      value={String(value ?? '18')}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 disabled:bg-gray-50 ${className}`}
    >
      {VENTAS_IGV_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default IgvRateSelect;
